import { Grid, InputAdornment, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { useRef, useState } from "react";
import {
  ContactForm,
  ContactFormValues,
  StyledTextField
} from "../../components/ContactForm";
import { FbtVsPayeCalculator } from "../../components/FbtVsPaye/FbtVsPayeCalculator";
import { Layout } from "../../components/Layout";
import { extraordinaryColors } from "../../utils/theme";
import { StyledButton } from "../gift-card/GiftCard";

export const FbtVsPaye = () => {
  const contactFormikRef = useRef<FormikProps<ContactFormValues>>();
  const [showResult, setShowResult] = useState(false);
  const [amount, setAmount] = useState<number | undefined>();

  const handleSubmit = () => {
    if (!contactFormikRef.current) return;
    contactFormikRef.current.handleSubmit();
  };

  return (
    <Layout>
      <Grid item xs={12}>
        <Typography variant="h2" sx={{ color: "white !important" }}>
          FBT vs PAYE analysis
        </Typography>
      </Grid>

      <Grid item xs={12} textAlign="left">
        {!showResult ? (
          <Grid item mt={10}>
            <ContactForm
              ref={contactFormikRef}
              webflowSlug="fbt-vs-paye"
              onSuccess={() => setShowResult(true)}
              color={extraordinaryColors.orange.main}
              headingColor="white"
            />

            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "20px",
                color: "white !important",
                mt: 5
              }}
            >
              Enter annual benefit amount{" "}
            </Typography>
            <Typography sx={{ mb: 1, color: "white !important" }}>
              (For example, a $200 or $500 annual contribution)
            </Typography>
            <StyledTextField
              textcolor={extraordinaryColors.orange.main}
              variant="standard"
              value={amount}
              type="number"
              onChange={(e) => setAmount(+e.target.value)}
              name="netBenefit"
              placeholder="Net Benefit"
              size="small"
              InputProps={{
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography
                      sx={{
                        color: extraordinaryColors.orange.main,
                        fontSize: 25,
                        fontWeight: 700,
                        fontFamily: "GT-Alpina-Condensed",
                        paddingBottom: 0.5
                      }}
                    >
                      $
                    </Typography>
                  </InputAdornment>
                )
              }}
              sx={{ mr: 1 }}
            />
          </Grid>
        ) : (
          <FbtVsPayeCalculator amount={amount} updateAmount={setAmount} />
        )}

        {!showResult && (
          <Grid container justifyContent="flex-end" mt={3}>
            <Grid item>
              <StyledButton
                backgroundcolor={extraordinaryColors.green.light}
                onClick={() => handleSubmit()}
              >
                Continue
              </StyledButton>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Layout>
  );
};
